export const GET_ROLES_LIST_REQUEST = "GET_ROLES_LIST_REQUEST";
export const GET_ROLES_LIST_RESPONSE = "GET_ROLES_LIST_RESPONSE";

export const UPDATE_ROLE_STATUS_REQUEST = "UPDATE_ROLES_STATUS_REQUEST";
export const UPDATE_ROLE_STATUS_RESPONSE = "UPDATE_ROLES_STATUS_RESPONSE";

export const GET_ROLE_REQUEST = "GET_ROLE_REQUEST";
export const GET_ROLE_RESPONSE = "GET_ROLE_RESPONSE";

export const EDIT_ROLE_REQUEST = "EDIT_ROLE_REQUEST";
export const EDIT_ROLE_RESPONSE = "EDIT_ROLE_RESPONSE";

export const UPDATE_ROLE_REQUEST = "UPDATE_ROLE_REQUEST";
export const UPDATE_ROLE_RESPONSE = "UPDATE_ROLE_RESPONSE";

export const CREATE_ROLE_REQUEST = "CREATE_ROLE_REQUEST";
export const CREATE_ROLE_RESPONSE = "CREATE_ROLE_RESPONSE";

export const DELETE_ROLE_REQUEST = "DELETE_ROLE_REQUEST";

export const PROMOTE_ROLE_REQUEST = "PROMOTE_ROLE_REQUEST";
export const PROMOTE_ROLE_RESPONSE = "PROMOTE_ROLE_RESPONSE";

export const DEMOTE_ROLE_REQUEST = "DEMOTE_ROLE_REQUEST";
export const DEMOTE_ROLE_RESPONSE = "DEMOTE_ROLE_RESPONSE";

export const GET_SINGLE_ROLE_REQUEST = "GET_SINGLE_ROLE_REQUEST";
export const GET_SINGLE_ROLE_RESPONSE = "GET_SINGLE_ROLE_RESPONSE";

export const UPDATE_SINGLE_ROLE_REQUEST = "UPDATE_SINGLE_ROLE_REQUEST";
export const UPDATE_SINGLE_ROLE_RESPONSE = "UPDATE_SINGLE_ROLE_RESPONSE";
